// import React, { useEffect, useRef, useState } from "react";
// import ChartComponent from "../ChartComponent";
// import { FiCrosshair } from "react-icons/fi";
// import { MdOutlineAddCircleOutline } from "react-icons/md";
// import TradingViewTopBar from "./ChartTopBar";
// import TradingViewWidget from "./ChartTopBar";
// import DrawflowEditor from "./DrawFlowEditor";
// import { useNavigate } from "react-router-dom";
// import { FaTrash } from "react-icons/fa";

// const AlgoPilot = () => {
//   const [contractType, setContractType] = useState("EQ");

//   const [showOptions, setShowOptions] = useState(false);
//   const [selectedIndicator, setSelectedIndicator] = useState(null);
//   const [showPopup, setShowPopup] = useState(false);
//   const [inputValue, setInputValue] = useState("");
//   const indicators = ["SMA", "EMA", "RSI", "MACD"];
//   const [activeTab, setActiveTab] = useState("strategy");

//   const handleSelect = (indicator) => {
//     setSelectedIndicator(indicator);
//     setShowOptions(false);
//     setShowPopup(true);
//   };

//   const [open, setOpen] = useState(false);

//   // Show popup automatically on mount
//   useEffect(() => {
//     setOpen(true);
//   }, []);
//   const navigate = useNavigate();

//   const handlebutton = () => {
//     navigate("/str");
//   };

//   const selectStyle =
//     "w-[12ch] sm:w-[14ch] md:w-[16ch] bg-white text-black border rounded h-9 px-2 text-sm";

//   const [bottomHeight, setBottomHeight] = useState(200);
//   const [isResizing, setIsResizing] = useState(false);

//   const handleMouseDown = () => {
//     setIsResizing(true);
//   };

//   const handleMouseMove = (e) => {
//     if (!isResizing) return;
//     const newHeight = window.innerHeight - e.clientY;
//     if (newHeight > 80 && newHeight < window.innerHeight - 150) {
//       setBottomHeight(newHeight);
//     }
//   };

//   const handleMouseUp = () => {
//     setIsResizing(false);
//   };

//   useEffect(() => {
//     window.addEventListener("mousemove", handleMouseMove);
//     window.addEventListener("mouseup", handleMouseUp);
//     return () => {
//       window.removeEventListener("mousemove", handleMouseMove);
//       window.removeEventListener("mouseup", handleMouseUp);
//     };
//   }, [isResizing]);

//   const adminCurrentRows = [
//     {
//       id: 1,
//       strategyName: "Breakout Strategy",
//       analyze: "Price Action",
//       indicator: "RSI",
//       condition: "RSI < 30",
//       strategy: "Buy on breakout with volume spike",
//       active: true,
//     },
//     {
//       id: 2,
//       strategyName: "Trend Reversal",
//       analyze: "Candle Pattern",
//       indicator: "EMA",
//       condition: "Price crosses below EMA 20",
//       strategy: "Sell on reversal signal confirmation",
//       active: false,
//     },
//     {
//       id: 3,
//       strategyName: "Scalping Quick Entry",
//       analyze: "Order Flow",
//       indicator: "VWAP",
//       condition: "Price above VWAP + Momentum",
//       strategy: "Instant entry and exit with tight stop loss",
//       active: true,
//     },
//   ];

//   return (
//     <div className="w-full h-screen">
//       <div className="fixed inset-0 pointer-events-none overflow-hidden">
//         <div className="absolute top-20 left-1/4 w-96 h-96 bg-gradient-to-r from-blue-200/40 to-purple-200/40 dark:from-blue-500/20 dark:to-purple-500/20 rounded-full blur-3xl animate-pulse-glow"></div>
//         <div className="absolute bottom-20 right-1/4 w-96 h-96 bg-gradient-to-r from-pink-200/40 to-orange-200/40 dark:from-pink-500/20 dark:to-orange-500/20 rounded-full blur-3xl animate-pulse-glow animation-delay-2000"></div>
//         <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-blue-100/20 to-purple-100/20 dark:from-blue-500/10 dark:to-purple-500/10 rounded-full blur-3xl"></div>
//       </div>

//       {/* 
//     {open && (
//   <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50">
//     <div className="bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white 
//                     rounded-xl shadow-xl px-6 py-4 w-80 max-w-sm text-center animate-fade-in">
//       <h2 className="text-xl font-bold mb-4">🚧 Coming Soon!</h2>
//       <p className="text-gray-600 dark:text-gray-300 mb-6 text-sm">
//         This feature is under development and will be available soon.
//       </p>
//     </div>
//   </div>
// )} */}

//       <div>
//         <div className="w-full flex justify-center items-center">
//           <div className="w-full flex justify-between items-center m-4">
//             <div className="inline-flex p-1 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg border border-gray-200/50 dark:border-gray-700/50">
//               <button
//                 onClick={() => setActiveTab("strategy")}
//                 className={`relative flex items-center justify-center gap-2 w-[150px] py-2.5 rounded-lg font-medium transition-all duration-300 overflow-hidden ${
//                   activeTab === "strategy"
//                     ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/40 glow-button"
//                     : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100/80 dark:hover:bg-gray-700/80"
//                 }`}
//               >
//                 {activeTab === "strategy" && (
//                   <span className="absolute inset-0 bg-gradient-to-r from-blue-400 to-blue-600 animate-pulse-glow opacity-50 shine-effect"></span>
//                 )}
//                 <span className="relative z-10">Strategy</span>
//               </button>
//             </div>

//             <div className="inline-flex p-1 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg border border-gray-200/50 dark:border-gray-700/50">
//               <button
//                 onClick={() => setActiveTab("result")}
//                 className={`relative flex items-center justify-center gap-2 w-[150px] py-2.5 rounded-lg font-medium transition-all duration-300 overflow-hidden ${
//                   activeTab === "result"
//                     ? "bg-gradient-to-r from-purple-500 to-purple-600 text-white shadow-lg shadow-purple-500/40 glow-button"
//                     : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100/80 dark:hover:bg-gray-700/80"
//                 }`}
//               >
//                 {activeTab === "result" && (
//                   <span className="absolute inset-0 bg-gradient-to-r from-purple-400 to-purple-600 animate-pulse-glow opacity-50 shine-effect"></span>
//                 )}
//                 <span className="relative z-10">Result</span>
//               </button>
//             </div>
//           </div>
//         </div>

//         {activeTab === "strategy" && (
//           <div className="w-full h-[calc(100vh-80px)] flex flex-col">
//             <div className="flex-1 overflow-auto shadow-2xl">
//               <div className="  backdrop-blur-md bg-white/70 dark:bg- dark:bg-[#1d1d1f] rounded-xl shadow-lg pl-4 pr-4 pb-4 min-w-[900px] min-h-[500px] ">
//                 <div className="flex justify-end items-center space-x-2 space-y-4"></div>

//                 {/* Columns for Table */}
//                 {/* Table start from here and table code   */}

//                 <table className="min-w-full table-auto text-xs text-left border border-[#94BBE9] ">
//                   <thead className="bg-blue-50 text-blue-800">
//                     <tr>
//                       <th className="min-w-[10px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                         <div className="flex items-center justify-between gap-1">
//                           Strategy Name
//                         </div>
//                       </th>
//                       <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                         <div className="flex items-center justify-between gap-1">
//                           Analyze
//                         </div>
//                       </th>

//                       <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                         <div className="flex items-center justify-between gap-1">
//                           Indicator
//                         </div>
//                       </th>

//                       <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                         <div className="flex items-center justify-between gap-1">
//                           Condition
//                         </div>
//                       </th>

//                       <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                         <div className="flex items-center justify-between gap-1">
//                           Status
//                         </div>
//                       </th>

//                       <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                         <div className="flex items-center justify-between gap-1">
//                           Active
//                         </div>
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {/* Rows for admin Table */}

//                     {/* Rows if admin table lenght is zero then show no data found */}

//                     {adminCurrentRows.length === 0 ? (
//                       <>
//                         <tr>
//                           <td
//                             colSpan={6} // adjust this number to match your total number of columns
//                             className=" min-w-[30px] text-center py-4 border border-[#94BBE9] text-gray-500 dark:text-black"
//                           >
//                             No alerts found
//                           </td>
//                         </tr>
//                       </>
//                     ) : (
//                       //  here is if data got from api then here data wil show
//                       Array.isArray(adminCurrentRows) &&
//                       adminCurrentRows.map((row, idx) => (
//                         <tr
//                           key={idx}
//                           className="border-b border-[#94BBE9] text-mytextlight dark:text-mytextdark "
//                         >
//                           <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9]  ">
//                             {row.strategyName}
//                           </td>

//                           {/* status the code if the user is not here logic for the status so ero erisksdj   */}
//                           <td className="min-w-[30px] px-2 py-2  border border-[#94BBE9] ">
//                             {row.analyze}
//                           </td>

//                           {/* * In this how to show quantity of the multiple data   */}

//                           <td className="min-w-[30px] px-2 py-2  border border-[#94BBE9] ">
//                             {row.indicator}
//                           </td>

//                           <td className="min-w-[30px] px-2 py-2  border border-[#94BBE9] ">
//                             {/* In this how to show quantity of the multiple data   */}
//                             {row.condition}
//                           </td>

//                           <td className="min-w-[30px] px-2 py-2 border  border-[#94BBE9] ">
//                             <div className=" flex gap-4 items-center">
//                               {row.status ? "Inactive" : "Active"}
//                             </div>
//                           </td>

//                           <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] ">
//                             {/* Status logic for status show the status of the code  */}

//                             {row.active}
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             {/* ---- DRAGGABLE DIVIDER ---- */}
//             <div
//               onMouseDown={handleMouseDown}
//               className="h-2 cursor-row-resize bg-gray-500 hover:bg-gray-600"
//             ></div>

//             {/* ---- BOTTOM PANEL (Resizable) ---- */}
//             <div
//               className="bg-[#1d1d1f] border-t border-slate-700 flex flex-col"
//               style={{ height: bottomHeight }}
//             >
//               {/* <button onClick={() => navigate('/drawflowview.html')}>
//       Open Editor
//     </button> */}
//               <DrawflowEditor />
//             </div>
//           </div>
//         )}

//         {activeTab === "result" && <div></div>}
//       </div>
//     </div>
//   );
// };

// export default AlgoPilot;

// // <div>
// //         <div className='"w-full flex justify-center items-center'>
// //           <div className="w-full flex justify-between items-center m-4">
// //             <div className="inline-flex p-1 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg border border-gray-200/50 dark:border-gray-700/50">
// //               <button
// //                 onClick={() => setActiveTab("strategy")}
// //                 className={`w-[150px] py-2 px-4 rounded-lg shadow-2xl border border-gray-200 ${activeTab === "strategy" ? "bg-blue-600 text-white" : "bg-white text-black"} `}
// //               >
// //                 Strategy
// //               </button>
// //             </div>

// //             <div>
// //               <button
// //                 onClick={() => setActiveTab("result")}
// //                 className={`w-[150px] py-2 px-4 rounded-lg  border border-gray-200 shadow-2xl ${activeTab === "result" ? "bg-blue-600 text-white" : " bg-white text-black"} `}
// //               >
// //                 Result
// //               </button>
// //             </div>
// //           </div>
// //         </div>





import React, { useEffect, useRef, useState } from "react";
import ChartComponent from "../ChartComponent";
import { FiCrosshair } from "react-icons/fi";
import { MdOutlineAddCircleOutline } from "react-icons/md";
import TradingViewTopBar from "./ChartTopBar";
import TradingViewWidget from "./ChartTopBar";
import DrawflowEditor from "./DrawFlowEditor";
import { useNavigate } from "react-router-dom";
import { FaTrash } from "react-icons/fa";

const AlgoPilot = () => {
  const [contractType, setContractType] = useState("EQ");

  const [showOptions, setShowOptions] = useState(false);
  const [selectedIndicator, setSelectedIndicator] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const indicators = ["SMA", "EMA", "RSI", "MACD"];
  const [activeTab, setActiveTab] = useState("strategy");

  const handleSelect = (indicator) => {
    setSelectedIndicator(indicator);
    setShowOptions(false);
    setShowPopup(true);
  };

  const [open, setOpen] = useState(false);

  // Show popup automatically on mount
  useEffect(() => {
    setOpen(true);
  }, []);
  const navigate = useNavigate();

  const handlebutton = () => {
    navigate("/str");
  };

  const selectStyle =
    "w-[12ch] sm:w-[14ch] md:w-[16ch] bg-white dark:bg-gray-700 text-black dark:text-white border rounded h-9 px-2 text-sm";

  const [bottomHeight, setBottomHeight] = useState(200);
  const [isResizing, setIsResizing] = useState(false);

  const handleMouseDown = () => {
    setIsResizing(true);
  };

  const handleMouseMove = (e) => {
    if (!isResizing) return;
    const newHeight = window.innerHeight - e.clientY;
    if (newHeight > 80 && newHeight < window.innerHeight - 150) {
      setBottomHeight(newHeight);
    }
  };

  const handleMouseUp = () => {
    setIsResizing(false);
  };

  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isResizing]);

  const adminCurrentRows = [
    {
      id: 1,
      strategyName: "Breakout Strategy",
      analyze: "Price Action",
      indicator: "RSI",
      condition: "RSI < 30",
      strategy: "Buy on breakout with volume spike",
      active: true,
    },
    {
      id: 2,
      strategyName: "Trend Reversal",
      analyze: "Candle Pattern",
      indicator: "EMA",
      condition: "Price crosses below EMA 20",
      strategy: "Sell on reversal signal confirmation",
      active: false,
    },
    {
      id: 3,
      strategyName: "Scalping Quick Entry",
      analyze: "Order Flow",
      indicator: "VWAP",
      condition: "Price above VWAP + Momentum",
      strategy: "Instant entry and exit with tight stop loss",
      active: true,
    },
  ];

  return (
    <div className="w-full h-screen bg-gray-50 dark:bg-gray-900">
      {/* Background Gradients - Dark Mode Adjusted */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-20 left-1/4 w-96 h-96 bg-gradient-to-r from-blue-200/40 to-purple-200/40 dark:from-blue-500/10 dark:to-purple-500/10 rounded-full blur-3xl animate-pulse-glow"></div>
        <div className="absolute bottom-20 right-1/4 w-96 h-96 bg-gradient-to-r from-pink-200/40 to-orange-200/40 dark:from-pink-500/10 dark:to-orange-500/10 rounded-full blur-3xl animate-pulse-glow animation-delay-2000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-blue-100/20 to-purple-100/20 dark:from-blue-500/5 dark:to-purple-500/5 rounded-full blur-3xl"></div>
      </div>

      <div>
        {/* Tab Navigation - Dark Mode Added */}
        <div className="w-full flex justify-center items-center">
          <div className="w-full flex justify-between items-center m-4">
            <div className="inline-flex p-1 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg border border-gray-200/50 dark:border-gray-700/50">
              <button
                onClick={() => setActiveTab("strategy")}
                className={`relative flex items-center justify-center gap-2 w-[150px] py-2.5 rounded-lg font-medium transition-all duration-300 overflow-hidden ${
                  activeTab === "strategy"
                    ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/40 glow-button"
                    : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100/80 dark:hover:bg-gray-700/80"
                }`}
              >
                {activeTab === "strategy" && (
                  <span className="absolute inset-0 bg-gradient-to-r from-blue-400 to-blue-600 animate-pulse-glow opacity-50 shine-effect"></span>
                )}
                <span className="relative z-10">Strategy</span>
              </button>
            </div>

            <div className="inline-flex p-1 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg border border-gray-200/50 dark:border-gray-700/50">
              <button
                onClick={() => setActiveTab("result")}
                className={`relative flex items-center justify-center gap-2 w-[150px] py-2.5 rounded-lg font-medium transition-all duration-300 overflow-hidden ${
                  activeTab === "result"
                    ? "bg-gradient-to-r from-purple-500 to-purple-600 text-white shadow-lg shadow-purple-500/40 glow-button"
                    : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100/80 dark:hover:bg-gray-700/80"
                }`}
              >
                {activeTab === "result" && (
                  <span className="absolute inset-0 bg-gradient-to-r from-purple-400 to-purple-600 animate-pulse-glow opacity-50 shine-effect"></span>
                )}
                <span className="relative z-10">Result</span>
              </button>
            </div>
          </div>
        </div>

        {activeTab === "strategy" && (
          <div className="w-full h-[calc(100vh-80px)] flex flex-col">
            <div className="flex-1 overflow-auto shadow-2xl">
              {/* Main Container - Dark Mode Added */}
              <div className="backdrop-blur-md bg-white/70 dark:bg-[#1d1d1f]/90 rounded-xl shadow-lg pl-4 pr-4 pb-4 min-w-[900px] min-h-[500px]">
                <div className="flex justify-end items-center space-x-2 space-y-4"></div>

                {/* Table - Dark Mode Added */}
                <table className="min-w-full table-auto text-xs text-left border border-[#94BBE9] dark:border-gray-700">
                  <thead className="bg-blue-50 dark:bg-gray-800 text-blue-800 dark:text-gray-200">
                    <tr>
                      <th className="min-w-[10px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                        <div className="flex items-center justify-between gap-1">
                          Strategy Name
                        </div>
                      </th>
                      <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                        <div className="flex items-center justify-between gap-1">
                          Analyze
                        </div>
                      </th>
                      <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                        <div className="flex items-center justify-between gap-1">
                          Indicator
                        </div>
                      </th>
                      <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                        <div className="flex items-center justify-between gap-1">
                          Condition
                        </div>
                      </th>
                      <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                        <div className="flex items-center justify-between gap-1">
                          Status
                        </div>
                      </th>
                      <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                        <div className="flex items-center justify-between gap-1">
                          Active
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {adminCurrentRows.length === 0 ? (
                      <tr>
                        <td
                          colSpan={6}
                          className="min-w-[30px] text-center py-4 border border-[#94BBE9] dark:border-gray-700 text-gray-500 dark:text-gray-400"
                        >
                          No alerts found
                        </td>
                      </tr>
                    ) : (
                      Array.isArray(adminCurrentRows) &&
                      adminCurrentRows.map((row, idx) => (
                        <tr
                          key={idx}
                          className="border-b border-[#94BBE9] dark:border-gray-700 text-mytextlight dark:text-gray-300"
                        >
                          <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                            {row.strategyName}
                          </td>
                          <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                            {row.analyze}
                          </td>
                          <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                            {row.indicator}
                          </td>
                          <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                            {row.condition}
                          </td>
                          <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                            <div className="flex gap-4 items-center">
                              <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                row.status 
                                  ? "bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400" 
                                  : "bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400"
                              }`}>
                                {row.status ? "Inactive" : "Active"}
                              </span>
                            </div>
                          </td>
                          <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                              row.active
                                ? "bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400"
                                : "bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400"
                            }`}>
                              {row.active ? "Active" : "Inactive"}
                            </span>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Draggable Divider - Dark Mode Added */}
            <div
              onMouseDown={handleMouseDown}
              className="h-2 cursor-row-resize bg-gray-400 dark:bg-gray-600 hover:bg-gray-500 dark:hover:bg-gray-500 transition-colors duration-200"
            ></div>

            {/* Bottom Panel (Resizable) - Dark Mode Added */}
            <div
              className="bg-white dark:bg-[#1d1d1f] border-t border-gray-200 dark:border-gray-700 flex flex-col"
              style={{ height: bottomHeight }}
            >
              <DrawflowEditor />
            </div>
          </div>
        )}

        {activeTab === "result" && (
          <div className="flex items-center justify-center h-[calc(100vh-80px)]">
            <div className="text-center p-8 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg">
              <h2 className="text-2xl font-bold text-gray-700 dark:text-gray-300 mb-2">
                Results Coming Soon
              </h2>
              <p className="text-gray-500 dark:text-gray-400">
                Strategy results will be displayed here
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AlgoPilot;